import { TBody } from '@twilio-paste/core/table';

import { TargetAuthHeaderFormValue } from '../types';

import { TargetAuthHeaderTableRow } from './TargetAuthHeaderTableRow';

interface TargetAuthHeaderTableBodyProps {
  authHeaders: TargetAuthHeaderFormValue[];
}

export function TargetAuthHeaderTableBody({ authHeaders }: TargetAuthHeaderTableBodyProps) {
  const activeHeaders = authHeaders.filter(({ removed }) => !removed);

  return (
    <TBody>
      {activeHeaders.map(authHeader => (
        <TargetAuthHeaderTableRow key={authHeader.name} authHeader={authHeader} />
      ))}
    </TBody>
  );
}
